exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".check-off-history {\n  border-top: 1px solid black;\n  margin-top: 10px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/checkoffs/check-off-history/check-off-history.component.less
// module id = ./src/app/checkoffs/check-off-history/check-off-history.component.less
// module chunks = 0